export default "__VITE_ASSET__DMZ3swS9__"